import { useEffect, useState } from 'react'
import AddIcon from '@mui/icons-material/Add'
import MinimizeIcon from '@mui/icons-material/Minimize'
import { Box } from '@mui/material'
import Grid from '@mui/material/Grid2'
import BookAppointmentDialog from './BookAnAppointmentDialogue'
import aboutus from "../assets/Images/aboutus-pic.jpg"
import Aos from 'aos'
import shape from "../assets/Images/shapes/Thred 07-01.png"
const locations = [
  {
    title: 'Hyderabad, Telangana',
    email: 'magnaidhospitals@gmail.com',
    phone: '+917993999044',
    locationUrl:
      'https://maps.app.goo.gl/ae7ic19m3CFTA5c48',
    locationDesc: "8-3-224/B/5, Metro pillar No.C, 1494,Yousufguda Main Rd., Yella Reddy Guda,Hyderabad, Telangana 500045",
  },

]
export default function Aboutvisitus() {
  const [openIndex, setOpenIndex] = useState(0)
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };
  useEffect(() => {
    Aos.init({ duration: 1000 }); // Initialize AOS
  }, []);
  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  return (
    <div>
      <div className='overflow-hidden py-[88px] lg:py-[240px] relative'>
        <div className='w-[90%] flex justify-center flex-col items-center xl:w-[1340px] mx-auto relative'>
          <div className='absolute lg:top-0 bottom-0 right-0'>
            <img
              src={shape}
              alt='shape'
              className='top-0 right-0 xl:w-[500px] lg:w-[400px] md:w-[450px] w-[200px] '
            />
          </div>
          <div className='relative w-full'>
            <div className='z-[1] relative'>
              <div className='flex justify-between md:flex-row flex-col items-center mb-[40px]'>
                <div className='me-auto w-full md:w-1/2' data-aos="fade-right">
                  <h2 className='text-[36px]  lg:text-[58px] font-heading  text-thickGreen leading-[1.138em] mb-[24px]'>
                    Come and visit us
                  </h2>
                  <p className='text-paraGreen font-body font-medium text-[18px] leading-[1.667em]'>
                    Best Multi-Speciality Hospital Redefined Healthcare in your
                    Neighborhood
                  </p>
                </div>
                <div className='w-full md:w-1/2 flex md:justify-center' data-aos="fade-left">
                  <button
                    onClick={handleOpenDialog}
                    className='bg-orange md:w-[251px] w-full  text-white py-6 rounded-full   font-medium  font-body text-[20px] leading-[1.112em] 
       transition-all duration-300 hover:bg-lightGreen hover:bg-opacity-90 
       hover:translate-y-[-3px] block md:inline-block text-center mr-[0] md:mr-[24px] mt-8 md:mt-0'
                  >
                    Book an Appointment
                  </button>
                </div>
              </div>
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={5}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <div data-aos="fade-up">
                      {locations.map((location, index) => (
                        <div
                          key={index}
                          className={`${index !== locations.length - 1
                            ? 'border-b border-gray-300'
                            : ''
                            }`}
                        >
                          <button
                            onClick={() =>
                              setOpenIndex(openIndex === index ? null : index)
                            }
                            className='flex justify-between w-full py-4  text-[#322151] text-2xl'
                          >
                            <h3 className='text-[38px] font-heading font-medium leading-[1.316em] text-thickGreen'>
                              {location.title}
                            </h3>
                            {openIndex === index ? (
                              <MinimizeIcon
                                className='text-thickGreen  '
                                fontSize='large'
                              />
                            ) : (
                              <AddIcon
                                className='text-thickGreen'
                                fontSize='large'
                              />
                            )}
                          </button>
                          {openIndex === index && (
                            <div className='pb-6 w-[432px]'>
                              <a href={`${location.locationUrl}`} className='text-paraGreen font-body font-medium text-[18px] leading-[1.667em] mb-[32px]'>
                                {location.locationDesc}
                              </a>
                              <div className='mt-4'>
                                <p className='text-[18px] text-lightGreen font-body font-medium mb-[12px]'>
                                  Email address
                                </p>
                                <div className='flex flex-col'>
                                  <a href="mailto:info@magnaid.com" className='text-[22px] text-thickGreen font-body font-medium'>
                                    info@magnaid.com
                                  </a>
                                  <a href={`mailto:${location.email}`} className='text-[22px] text-thickGreen font-body font-medium'>
                                    {location.email}
                                  </a>
                                </div>
                              </div>
                              <div className='my-[24px]  border-b border-gray-300 w-[260px]'></div>
                              <div className='mt-4 flex flex-col'>
                                <p className='text-[18px] text-lightGreen font-body font-medium mb-[12px]'>
                                  Phone number
                                </p>
                                <a href="tel:+917993999040" className='text-[22px] text-thickGreen font-body '>
                                  7993 999 040
                                </a>
                                <a href={`tel:${location.phone}`} className='text-[22px] text-thickGreen font-body'>
                                  7993 999 044
                                </a>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <div className='xl:w-[560px] w-full flex justify-center items-center' data-aos="zoom-in" data-aos-easing="ease-in-back"
                    >
                      <div>
                        <img
                          loading='eager'
                          src={aboutus}
                          alt='top hospitals in hyderabad '
                          className='w-full h-cover-full rounded-[24px]'
                        />
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Box>
            </div>

          </div>
        </div>
      </div>
      <BookAppointmentDialog open={dialogOpen} onClose={handleCloseDialog} />
    </div>
  )
}
